import * as React from "react";
const SvgOrderLinePattern = props => <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1155 1000" {...props}><path d="m577.3 0 577.4 1000H0z" fill="#fff" /></svg>;
export default SvgOrderLinePattern;